import axios from "axios";
import { ListResponse } from "./utils";
import { environment } from "../../environments/environment";

export const listJobTitles = async (): Promise<ListResponse<any>> => {
    const response = await axios.post(`${environment.apiUrl}/graphql`,
        {
          "operationName": "AllJobs",
          "query": `query AllJobs {
                        allJobTitles {
                            id
                            name
                        }
                    }`,
          "variables": {}
        }, {
          headers: {
            "content-type": "application/json"
          }
        }
    );

    if(response.status !== 200) {
        throw Error('error');
    };

    const data = response.data.data.allJobTitles.map((item: any) => ({ ...item, id: parseInt(item.id) }));

    return { results: data, count: data.length };
};